import { render } from "./SupervisorPanel.vue?vue&type=template&id=7de1fda2&scoped=true"
import script from "./SupervisorPanel.vue?vue&type=script&lang=js"
export * from "./SupervisorPanel.vue?vue&type=script&lang=js"

import "./SupervisorPanel.vue?vue&type=style&index=0&id=7de1fda2&scoped=true&lang=css"

import exportComponent from "C:\\_Development\\JavaScript\\Vue\\flightlog\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de1fda2"]])

export default __exports__